// extracted by mini-css-extract-plugin
export default {"labelNumber":"labelNumber-ULne7","counterInput":"counterInput-ucOq4","hasError":"hasError-r41C9","boldText":"boldText-Bl86L","label":"label-dokmC"};